import { defineComponent as _defineComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'UiSettingsSection',
  props: {
    title: { type: String, required: false, default: '' },
    footer: { type: String, required: false, default: '' },
    variant: { type: String, required: false, default: 'default' },
    divided: { type: Boolean, required: false, default: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();



const __returned__ = {  }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})